<template>
  <v-container fluid fill-height class="background fill-height">
    <v-card class="white mx-auto" width="30vw" height="50vh" min-height="480px">
      
      <div class="white mb-3">
        <v-img max-width="20vw" class="mx-auto" src="../assets/DigiWheel_Logo_Evolution_Company_RGB_Yellow_Black.svg"/>
      </div>


      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        class="text-center"
      >
        <v-text-field
          v-model="password"
          :placeholder="$t('resetPassword.newPassword')"
          :rules="passwordRules"
          class="mb-n2 rounded-lg mx-auto"
          style="width: 70%"
          outlined
          density="compact"
          single-line
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
        ></v-text-field>

        <v-text-field
          v-model="confirmPassword"
          :placeholder="$t('resetPassword.confirmPassword')"
          :rules="confirmPasswordRules"
          class="mb-n2 rounded-lg mx-auto"
          style="width: 70%"
          outlined
          density="compact"
          single-line
          :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showConfirmPassword ? 'text' : 'password'"
          @click:append="showConfirmPassword = !showConfirmPassword"
        ></v-text-field>

        <v-btn
          style="width: 70%"
          color="black white--text"
          class="rounded-lg mb-3"
          :disabled="!valid || loading"
          :loading="loading"
          @click="changePassword"
        >
          {{ $t('resetPassword.changeButton') }}
        </v-btn>
      </v-form>

      <v-alert
        v-if="errorMessage"
        type="error"
        class="mx-8 mt-4"
        dense
      >
        {{ errorMessage }}
      </v-alert>

    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "ChangePassword",
  data: () => ({
    valid: false,
    password: '',
    confirmPassword: '',
    showPassword: false,
    showConfirmPassword: false,
    loading: false,
    errorMessage: '',
    passwordRules: [
      v => !!v || 'Password is required',
      v => (v && v.length >= 8) || 'Password must be at least 8 characters',
      v => {
        if (!v) return true;
        // Prevent XSS attack characters
        const forbiddenChars = /<|>|&|'|"|`|\\\\|;/;
        if (forbiddenChars.test(v)) {
          return 'Password contains invalid characters';
        }
        return true;
      }
    ]
  }),
  computed: {
    ...mapGetters(['getPasswordResetEmail', 'getCodeVerified']),
    confirmPasswordRules() {
      return [
        v => !!v || 'Please confirm your password',
        v => v === this.password || this.$t('resetPassword.errors.passwordMismatch')
      ];
    }
  },
  mounted() {
    // If no email or code not verified, redirect back
    if (!this.getPasswordResetEmail || !this.getCodeVerified) {
      this.$router.push('/resetpassword');
    }
  },
  methods: {
    ...mapActions(['resetPassword']),
    async changePassword() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;
      this.errorMessage = '';

      try {
        const result = await this.resetPassword({
          email: this.getPasswordResetEmail,
          newPassword: this.password
        });
        
        if (result.success) {
          this.$toast.success(this.$t('resetPassword.passwordChanged'));
          this.$router.push('/login');
        } else {
          this.errorMessage = result.error || 'Failed to change password. Please try again.';
        }
      } catch (error) {
        this.errorMessage = 'An error occurred. Please try again.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.background {
  background-color: #f5f5f5;
}
</style>